import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export const initEnterAnimation = () => {
	const banner = document.querySelector('.banner')
	
	if (!banner) return
	
	// const heading = banner.querySelector('.banner__heading')

	// const splitHeading = SplitText.create(heading, {
	// 	type: 'lines, chars',
	// 	linesClass: 'line++',
	// 	mask: 'lines'
	// })

	const tl = gsap.timeline({ delay: 1 })

}